import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _16d47d7e = () => interopDefault(import('../pages/pelletspreise/index.vue' /* webpackChunkName: "pages/pelletspreise/index" */))
const _5b22c454 = () => interopDefault(import('../pages/pelletspreise/bestellung/index.vue' /* webpackChunkName: "pages/pelletspreise/bestellung/index" */))
const _57af4f0b = () => interopDefault(import('../pages/pelletspreise/bundeslaender/index.vue' /* webpackChunkName: "pages/pelletspreise/bundeslaender/index" */))
const _e2fee8ea = () => interopDefault(import('../pages/pelletspreise/pellets-checkout/index.vue' /* webpackChunkName: "pages/pelletspreise/pellets-checkout/index" */))
const _7d7afdce = () => interopDefault(import('../pages/pelletspreise/pellets-checkout/index/index.vue' /* webpackChunkName: "pages/pelletspreise/pellets-checkout/index/index" */))
const _609c862b = () => interopDefault(import('../pages/pelletspreise/pellets-checkout/index/adresse.vue' /* webpackChunkName: "pages/pelletspreise/pellets-checkout/index/adresse" */))
const _a4e53680 = () => interopDefault(import('../pages/pelletspreise/pellets-checkout/index/entladestellen.vue' /* webpackChunkName: "pages/pelletspreise/pellets-checkout/index/entladestellen" */))
const _a40a6902 = () => interopDefault(import('../pages/pelletspreise/pellets-checkout/index/success.vue' /* webpackChunkName: "pages/pelletspreise/pellets-checkout/index/success" */))
const _faea6b46 = () => interopDefault(import('../pages/pelletspreise/pellets-checkout/index/zusammenfassung.vue' /* webpackChunkName: "pages/pelletspreise/pellets-checkout/index/zusammenfassung" */))
const _70a398b1 = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index" */))
const _341c2062 = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/gas-auf-pellets.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/gas-auf-pellets" */))
const _07f51b64 = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/heizwert-pellets.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/heizwert-pellets" */))
const _651b3873 = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/holzpellets-preis-zusammensetzung.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/holzpellets-preis-zusammensetzung" */))
const _5d9d63c5 = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/holzpellets-qualitaet.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/holzpellets-qualitaet" */))
const _7f11a4df = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/oel-auf-pellets.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/oel-auf-pellets" */))
const _54e5b442 = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pelletheizung-asche.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pelletheizung-asche" */))
const _6f69a3ba = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pelletheizung-vorteile-nachteile.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pelletheizung-vorteile-nachteile" */))
const _27d9bad0 = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pelletheizung-wartung-kosten.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pelletheizung-wartung-kosten" */))
const _76cb58fd = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pelletheizung-wirkungsgrad.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pelletheizung-wirkungsgrad" */))
const _09b9e43d = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pelletlager.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pelletlager" */))
const _42b8e330 = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pelletlager-reinigung.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pelletlager-reinigung" */))
const _68078ddb = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pelletlager-selbst-bauen.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pelletlager-selbst-bauen" */))
const _033728f7 = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pelletofen-vs-pelletheizung.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pelletofen-vs-pelletheizung" */))
const _ce1e8414 = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pelletofen-zusatzheizung.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pelletofen-zusatzheizung" */))
const _8e59b5fa = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pellets-herstellung.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pellets-herstellung" */))
const _0af2feaa = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pellets-sackware-lose-ware-vergleich.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pellets-sackware-lose-ware-vergleich" */))
const _63ddcf8a = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pellets-zertifikate.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pellets-zertifikate" */))
const _64632a5f = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pelletsheizung.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pelletsheizung" */))
const _737a58ab = () => interopDefault(import('../pages/pelletspreise/pellets-ratgeber/index/pelletsverbrauch.vue' /* webpackChunkName: "pages/pelletspreise/pellets-ratgeber/index/pelletsverbrauch" */))
const _562f7565 = () => interopDefault(import('../pages/pelletspreise/services/index.vue' /* webpackChunkName: "pages/pelletspreise/services/index" */))
const _13d2a7dd = () => interopDefault(import('../pages/pelletspreise/services/index/mindestbestellmenge.vue' /* webpackChunkName: "pages/pelletspreise/services/index/mindestbestellmenge" */))
const _0f05ab35 = () => interopDefault(import('../pages/pelletspreise/services/index/pelletlieferung.vue' /* webpackChunkName: "pages/pelletspreise/services/index/pelletlieferung" */))
const _74e5fd02 = () => interopDefault(import('../pages/pelletspreise/services/index/pellets-bestellen.vue' /* webpackChunkName: "pages/pelletspreise/services/index/pellets-bestellen" */))
const _53d8a8d2 = () => interopDefault(import('../pages/pelletspreise/services/index/zahlarten.vue' /* webpackChunkName: "pages/pelletspreise/services/index/zahlarten" */))
const _3388ffab = () => interopDefault(import('../pages/pelletspreise/widerruf/index.vue' /* webpackChunkName: "pages/pelletspreise/widerruf/index" */))
const _85fd268c = () => interopDefault(import('../pages/charts/charts/charts-screenshot-service.vue' /* webpackChunkName: "pages/charts/charts/charts-screenshot-service" */))
const _4bb846ce = () => interopDefault(import('../pages/pelletspreise/bundeslaender/_category/index.vue' /* webpackChunkName: "pages/pelletspreise/bundeslaender/_category/index" */))
const _a7c9f9f8 = () => interopDefault(import('../pages/pelletspreise/bundeslaender/_category/_id/index.vue' /* webpackChunkName: "pages/pelletspreise/bundeslaender/_category/_id/index" */))
const _27d2ad2e = () => interopDefault(import('../pages/pelletspreise/_id/index.vue' /* webpackChunkName: "pages/pelletspreise/_id/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/pelletspreise",
    component: _16d47d7e,
    name: "pelletspreise"
  }, {
    path: "/pelletspreise/bestellung",
    component: _5b22c454,
    name: "pelletspreise-bestellung"
  }, {
    path: "/pelletspreise/bundeslaender",
    component: _57af4f0b,
    name: "pelletspreise-bundeslaender"
  }, {
    path: "/pelletspreise/pellets-checkout",
    component: _e2fee8ea,
    children: [{
      path: "",
      component: _7d7afdce,
      name: "pelletspreise-pellets-checkout-index"
    }, {
      path: "adresse",
      component: _609c862b,
      name: "pelletspreise-pellets-checkout-index-adresse"
    }, {
      path: "entladestellen",
      component: _a4e53680,
      name: "pelletspreise-pellets-checkout-index-entladestellen"
    }, {
      path: "success",
      component: _a40a6902,
      name: "pelletspreise-pellets-checkout-index-success"
    }, {
      path: "zusammenfassung",
      component: _faea6b46,
      name: "pelletspreise-pellets-checkout-index-zusammenfassung"
    }]
  }, {
    path: "/pelletspreise/pellets-ratgeber",
    component: _70a398b1,
    name: "pelletspreise-pellets-ratgeber",
    children: [{
      path: "gas-auf-pellets",
      component: _341c2062,
      name: "pelletspreise-pellets-ratgeber-index-gas-auf-pellets"
    }, {
      path: "heizwert-pellets",
      component: _07f51b64,
      name: "pelletspreise-pellets-ratgeber-index-heizwert-pellets"
    }, {
      path: "holzpellets-preis-zusammensetzung",
      component: _651b3873,
      name: "pelletspreise-pellets-ratgeber-index-holzpellets-preis-zusammensetzung"
    }, {
      path: "holzpellets-qualitaet",
      component: _5d9d63c5,
      name: "pelletspreise-pellets-ratgeber-index-holzpellets-qualitaet"
    }, {
      path: "oel-auf-pellets",
      component: _7f11a4df,
      name: "pelletspreise-pellets-ratgeber-index-oel-auf-pellets"
    }, {
      path: "pelletheizung-asche",
      component: _54e5b442,
      name: "pelletspreise-pellets-ratgeber-index-pelletheizung-asche"
    }, {
      path: "pelletheizung-vorteile-nachteile",
      component: _6f69a3ba,
      name: "pelletspreise-pellets-ratgeber-index-pelletheizung-vorteile-nachteile"
    }, {
      path: "pelletheizung-wartung-kosten",
      component: _27d9bad0,
      name: "pelletspreise-pellets-ratgeber-index-pelletheizung-wartung-kosten"
    }, {
      path: "pelletheizung-wirkungsgrad",
      component: _76cb58fd,
      name: "pelletspreise-pellets-ratgeber-index-pelletheizung-wirkungsgrad"
    }, {
      path: "pelletlager",
      component: _09b9e43d,
      name: "pelletspreise-pellets-ratgeber-index-pelletlager"
    }, {
      path: "pelletlager-reinigung",
      component: _42b8e330,
      name: "pelletspreise-pellets-ratgeber-index-pelletlager-reinigung"
    }, {
      path: "pelletlager-selbst-bauen",
      component: _68078ddb,
      name: "pelletspreise-pellets-ratgeber-index-pelletlager-selbst-bauen"
    }, {
      path: "pelletofen-vs-pelletheizung",
      component: _033728f7,
      name: "pelletspreise-pellets-ratgeber-index-pelletofen-vs-pelletheizung"
    }, {
      path: "pelletofen-zusatzheizung",
      component: _ce1e8414,
      name: "pelletspreise-pellets-ratgeber-index-pelletofen-zusatzheizung"
    }, {
      path: "pellets-herstellung",
      component: _8e59b5fa,
      name: "pelletspreise-pellets-ratgeber-index-pellets-herstellung"
    }, {
      path: "pellets-sackware-lose-ware-vergleich",
      component: _0af2feaa,
      name: "pelletspreise-pellets-ratgeber-index-pellets-sackware-lose-ware-vergleich"
    }, {
      path: "pellets-zertifikate",
      component: _63ddcf8a,
      name: "pelletspreise-pellets-ratgeber-index-pellets-zertifikate"
    }, {
      path: "pelletsheizung",
      component: _64632a5f,
      name: "pelletspreise-pellets-ratgeber-index-pelletsheizung"
    }, {
      path: "pelletsverbrauch",
      component: _737a58ab,
      name: "pelletspreise-pellets-ratgeber-index-pelletsverbrauch"
    }]
  }, {
    path: "/pelletspreise/services",
    component: _562f7565,
    name: "pelletspreise-services",
    children: [{
      path: "mindestbestellmenge",
      component: _13d2a7dd,
      name: "pelletspreise-services-index-mindestbestellmenge"
    }, {
      path: "pelletlieferung",
      component: _0f05ab35,
      name: "pelletspreise-services-index-pelletlieferung"
    }, {
      path: "pellets-bestellen",
      component: _74e5fd02,
      name: "pelletspreise-services-index-pellets-bestellen"
    }, {
      path: "zahlarten",
      component: _53d8a8d2,
      name: "pelletspreise-services-index-zahlarten"
    }]
  }, {
    path: "/pelletspreise/widerruf",
    component: _3388ffab,
    name: "pelletspreise-widerruf"
  }, {
    path: "/charts/charts/charts-screenshot-service",
    component: _85fd268c,
    name: "charts-charts-charts-screenshot-service"
  }, {
    path: "/pelletspreise/bundeslaender/:category",
    component: _4bb846ce,
    name: "pelletspreise-bundeslaender-category"
  }, {
    path: "/pelletspreise/bundeslaender/:category/:id",
    component: _a7c9f9f8,
    name: "pelletspreise-bundeslaender-category-id"
  }, {
    path: "/pelletspreise/:id",
    component: _27d2ad2e,
    name: "pelletspreise-id"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
